var map = {
	"./case.svg": "CcGu",
	"./collapse.svg": "cD3V",
	"./cost.svg": "2a9B",
	"./custom.svg": "0LDi",
	"./document.svg": "hzSG",
	"./domain.svg": "iwpg",
	"./flag-ae.svg": "rbYN",
	"./flag-at.svg": "SuRi",
	"./flag-be.svg": "L/kk",
	"./flag-bg.svg": "uiqu",
	"./flag-cy.svg": "RSuz",
	"./flag-cz.svg": "6Art",
	"./flag-de.svg": "TeVf",
	"./flag-dk.svg": "Dsds",
	"./flag-ee.svg": "zHIk",
	"./flag-es.svg": "1PeB",
	"./flag-eu.svg": "/QEv",
	"./flag-fi.svg": "8naE",
	"./flag-fr.svg": "zIor",
	"./flag-gb.svg": "hcyc",
	"./flag-gr.svg": "IKMD",
	"./flag-hr.svg": "rtK7",
	"./flag-hu.svg": "5tny",
	"./flag-ie.svg": "Fm5s",
	"./flag-it.svg": "HgeY",
	"./flag-jp.svg": "AK5P",
	"./flag-lt.svg": "lApx",
	"./flag-lu.svg": "OCMx",
	"./flag-lv.svg": "/5pr",
	"./flag-mt.svg": "K39K",
	"./flag-mx.svg": "OP7p",
	"./flag-nl.svg": "YWUD",
	"./flag-pl.svg": "Ztis",
	"./flag-pt.svg": "qGRZ",
	"./flag-ro.svg": "BP3n",
	"./flag-sa.svg": "u0yF",
	"./flag-se.svg": "Mvad",
	"./flag-si.svg": "UPPV",
	"./flag-sk.svg": "JuHE",
	"./home.svg": "5COo",
	"./mini-program.svg": "98By",
	"./pay-alipay.svg": "S7Jq",
	"./pay-bank.svg": "jTNZ",
	"./pay-days.svg": "O19/",
	"./pay-taobao.svg": "8XZN",
	"./pay-wechat.svg": "Jr3b",
	"./search.svg": "dZHa",
	"./system.svg": "zz4u",
	"./to-top.svg": "dVoA",
	"./tool.svg": "8b2j",
	"./vat.svg": "orEG",
	"./wechat.svg": "V+eR",
	"./workbench.svg": "1SAd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tJe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons nonrecursive \.svg$
// module id = /tJe
// module chunks = 24